(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["df-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBar(bar) {
      if (bar.dataset.dfInit === '1') return;
      bar.dataset.dfInit = '1';
      var items = Array.prototype.slice.call(bar.querySelectorAll('[data-df-ann-item]'));
      if (items.length < 2) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var mobile = window.matchMedia('(max-width: 989px)');
      var interval = parseInt(bar.getAttribute('data-df-interval'), 10) || 4000;
      var current = 0;
      var timer = null;

      function show(i) {
        items[current].classList.remove('is-active');
        items[current].setAttribute('aria-hidden', 'true');
        current = (i + items.length) % items.length;
        items[current].classList.add('is-active');
        items[current].removeAttribute('aria-hidden');
      }
      function startTimer() {
        if (reduce) return;
        if (timer) clearInterval(timer);
        timer = setInterval(function () {
          // Rotate only on mobile — desktop shows all messages inline via CSS
          if (!mobile.matches) return;
          show(current + 1);
        }, interval);
      }
      startTimer();

      var prevBtn = bar.querySelector('[data-df-ann-prev]');
      var nextBtn = bar.querySelector('[data-df-ann-next]');
      if (prevBtn) { prevBtn.addEventListener('click', function () { show(current - 1); startTimer(); }); }
      if (nextBtn) { nextBtn.addEventListener('click', function () { show(current + 1); startTimer(); }); }
      // On desktop, all items must be visible to assistive tech
      var syncAria = function () {
        if (!mobile.matches) {
          items.forEach(function (it) { it.removeAttribute('aria-hidden'); });
        } else {
          items.forEach(function (it, i) {
            if (i === current) { it.removeAttribute('aria-hidden'); }
            else { it.setAttribute('aria-hidden', 'true'); }
          });
        }
      };
      syncAria();
      if (mobile.addEventListener) { mobile.addEventListener('change', syncAria); }
    }
    function boot() {
      document.querySelectorAll('.df-announcement[data-df-rotate]').forEach(initBar);
    }
    if (document.readyState !== 'loading') { boot(); }
    else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["df-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var body = document.body;

    function openPanel(el) { if (!el) return; el.hidden = false; requestAnimationFrame(function(){ el.classList.add('is-open'); }); body.classList.add('df-no-scroll'); }
    function closePanel(el) { if (!el) return; el.classList.remove('is-open'); body.classList.remove('df-no-scroll'); setTimeout(function(){ el.hidden = true; }, 280); }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = (precision == null) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var value = (number / 100).toFixed(precision);
      var parts = value.split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var decPart = parts[1] ? decimal + parts[1] : '';
      return intPart + decPart;
    }
    var moneyPlaceholder = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
    function money(cents) {
      var fmt = window.dfMoneyFormat || '';
      var match = fmt.match(moneyPlaceholder);
      if (!fmt || !match) { return formatWithDelimiters(cents, 2); }
      var token = match[1];
      var value;
      switch (token) {
        case 'amount': value = formatWithDelimiters(cents, 2); break;
        case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
        case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.'); break;
        case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
        default: value = formatWithDelimiters(cents, 2);
      }
      return fmt.replace(moneyPlaceholder, value);
    }
    function moneyFromString(str) {
      var fmt = window.dfMoneyFormat || '';
      var match = fmt.match(moneyPlaceholder);
      if (!fmt || !match) return str;
      return fmt.replace(moneyPlaceholder, str);
    }

    /* ---------- Panels (menu / cart) ---------- */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-df-open-menu],[data-df-close-menu],[data-df-cart-toggle],[data-df-close-cart]');
      if (!t) return;

      if (t.hasAttribute('data-df-open-menu')) { e.preventDefault(); openPanel(document.querySelector('[data-df-mobile]')); }
      else if (t.hasAttribute('data-df-close-menu')) { e.preventDefault(); closePanel(document.querySelector('[data-df-mobile]')); }
      else if (t.hasAttribute('data-df-cart-toggle')) {
        var hd = document.querySelector('df-header');
        var behavior = hd ? hd.getAttribute('data-cart-behavior') : 'drawer';
        if (behavior === 'page') return;
        e.preventDefault();
        openCart();
      }
      else if (t.hasAttribute('data-df-close-cart')) { e.preventDefault(); closePanel(document.querySelector('[data-df-cart]')); }
    });

    /* ---------- Mega menu (All Categories) ---------- */
    var allcatsBtn = document.querySelector('[data-df-allcats]');
    var mega = document.querySelector('[data-df-mega]');
    function positionMega() {
      if (!mega) return;
      // Open directly below the trust bar when it immediately follows the header
      var navrow = mega.closest('[data-df-navrow]');
      var trustbar = document.querySelector('.df-trustbar-section .df-trustbar, .df-trustbar');
      var offset = 0;
      if (navrow && trustbar) {
        var nb = navrow.getBoundingClientRect();
        var tb = trustbar.getBoundingClientRect();
        if (tb.top >= nb.bottom - 2 && tb.top - nb.bottom < 120) {
          offset = tb.bottom - nb.bottom;
        }
      }
      mega.style.top = offset > 0 ? 'calc(100% + ' + Math.round(offset) + 'px)' : '100%';
    }
    function openMega() {
      if (!mega || !allcatsBtn) return;
      positionMega();
      mega.hidden = false;
      allcatsBtn.setAttribute('aria-expanded', 'true');
      body.classList.add('df-mega-open');
    }
    function closeMega() {
      if (!mega || !allcatsBtn) return;
      mega.hidden = true;
      allcatsBtn.setAttribute('aria-expanded', 'false');
      body.classList.remove('df-mega-open');
    }
    if (allcatsBtn && mega) {
      allcatsBtn.addEventListener('click', function () {
        if (mega.hidden) { openMega(); } else { closeMega(); }
      });
      document.addEventListener('click', function (e) {
        if (mega.hidden) return;
        if (!e.target.closest('[data-df-mega]') && !e.target.closest('[data-df-allcats]')) closeMega();
      });
      window.addEventListener('resize', function () {
        if (!mega.hidden) positionMega();
      });
    }

    /* ---------- Mega menu auto-open (desktop, homepage) ---------- */
    var headerRoot = document.querySelector('df-header.df-header');
    var megaDesktopMq = window.matchMedia('(min-width: 1200px)');
    function canAutoOpenMega() {
      return megaDesktopMq.matches &&
        headerRoot && !headerRoot.classList.contains('df-is-stuck') &&
        window.scrollY < 80;
    }
    if (allcatsBtn && mega && headerRoot && headerRoot.getAttribute('data-mega-auto') === 'true') {
      if (canAutoOpenMega()) { openMega(); }

      // Close when the user starts scrolling down the page
      var megaLastY = window.scrollY;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (!mega.hidden && y > megaLastY + 4 && y > 30) closeMega();
        megaLastY = y;
      }, { passive: true });

      // Re-open automatically when the pointer returns to the header area
      headerRoot.addEventListener('mouseenter', function () {
        if (mega.hidden && canAutoOpenMega()) openMega();
      });
      allcatsBtn.addEventListener('mouseenter', function () {
        if (mega.hidden && canAutoOpenMega()) openMega();
      });

      // Leaving desktop width closes it; returning re-opens at top of page
      var onMegaMqChange = function (e) {
        if (!e.matches) { closeMega(); }
        else if (canAutoOpenMega()) { openMega(); }
      };
      if (megaDesktopMq.addEventListener) { megaDesktopMq.addEventListener('change', onMegaMqChange); }
      else if (megaDesktopMq.addListener) { megaDesktopMq.addListener(onMegaMqChange); }
    }

    /* ---------- Mobile category panel (auto-open + triggers) ---------- */
    var mobcats = document.querySelector('[data-df-mobcats]');
    var mobileCatsMq = window.matchMedia('(max-width: 989px)');
    var bnCatsBtn = document.querySelector('[data-df-bn-cats]');
    function syncMobcatsTriggers() {
      if (bnCatsBtn && mobcats) bnCatsBtn.setAttribute('aria-expanded', mobcats.hidden ? 'false' : 'true');
    }
    function closeMobcats() { if (mobcats) { mobcats.hidden = true; syncMobcatsTriggers(); } }
    function openMobcats() { if (mobcats) { mobcats.hidden = false; syncMobcatsTriggers(); } }
    if (mobcats) {
      // Auto-open on the homepage (Theme Editor setting)
      if (headerRoot && headerRoot.getAttribute('data-mobcats-auto') === 'true' && mobileCatsMq.matches && window.scrollY < 80) {
        openMobcats();
      }

      var mobcatsCloseBtn = mobcats.querySelector('[data-df-mobcats-close]');
      if (mobcatsCloseBtn) { mobcatsCloseBtn.addEventListener('click', closeMobcats); }

      // Re-open through the "Shop All" chip (instead of navigating)
      document.querySelectorAll('a.df-header__chip').forEach(function (chip) {
        var href = chip.getAttribute('href') || '';
        if (href.replace(/\/$/, '').indexOf('/collections/all') === -1) return;
        chip.setAttribute('data-df-shopall', '');
        chip.addEventListener('click', function (e) {
          if (!mobileCatsMq.matches) return;
          e.preventDefault();
          if (mobcats.hidden) { openMobcats(); } else { closeMobcats(); }
        });
      });

      // Bottom navigation "Categories" toggles the panel
      if (bnCatsBtn) {
        bnCatsBtn.addEventListener('click', function () {
          if (mobcats.hidden) {
            window.scrollTo({ top: 0, behavior: 'auto' });
            openMobcats();
          } else {
            closeMobcats();
          }
        });
      }

      // Tap outside the card closes it (triggers excluded)
      document.addEventListener('click', function (e) {
        if (mobcats.hidden) return;
        if (e.target.closest('.df-header__mobcats-card')) return;
        if (e.target.closest('[data-df-bn-cats]') || e.target.closest('[data-df-shopall]')) return;
        closeMobcats();
      });

      // Scrolling down closes it
      var mobcatsLastY = window.scrollY;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (!mobcats.hidden && y > mobcatsLastY + 4 && y > 30) closeMobcats();
        mobcatsLastY = y;
      }, { passive: true });

      // Leaving mobile width closes it
      var onMobcatsMqChange = function (e) { if (!e.matches) closeMobcats(); };
      if (mobileCatsMq.addEventListener) { mobileCatsMq.addEventListener('change', onMobcatsMqChange); }
      else if (mobileCatsMq.addListener) { mobileCatsMq.addListener(onMobcatsMqChange); }
    }

    /* ---------- Bottom navigation: stay clear of the Shopify preview bar ---------- */
    function dfOffsetForPreviewBar() {
      var bn = document.querySelector('[data-df-bottomnav]');
      if (!bn) return;
      var pbar = document.getElementById('PBarNextFrameWrapper');
      if (!pbar) return;
      var r = pbar.getBoundingClientRect();
      // Only offset when the preview bar is docked at the bottom of the viewport
      if (r.height > 0 && r.height < 160 && Math.abs(r.bottom - window.innerHeight) < 4) {
        bn.style.bottom = r.height + 'px';
        return true;
      }
    }
    var pbarTries = 0;
    var pbarTimer = setInterval(function () {
      pbarTries += 1;
      if (dfOffsetForPreviewBar() || pbarTries > 12) clearInterval(pbarTimer);
    }, 800);

    /* ---------- Bottom navigation: search shortcut ---------- */
    var bnSearchBtn = document.querySelector('[data-df-bn-search]');
    if (bnSearchBtn) {
      bnSearchBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'auto' });
        var si = document.querySelector('[data-df-search-input]');
        if (si) { si.focus(); }
      });
    }

    /* ---------- Predictive search ---------- */
    var searchWrap = document.querySelector('[data-df-search-wrap]');
    if (searchWrap) {
      var input = searchWrap.querySelector('[data-df-search-input]');
      var panel = searchWrap.querySelector('[data-df-predictive]');
      var list = searchWrap.querySelector('[data-df-predictive-list]');
      var allLink = searchWrap.querySelector('[data-df-predictive-all]');
      var catSelect = searchWrap.querySelector('[data-df-search-cat]');
      var form = searchWrap.querySelector('form');
      var debounce = null;
      var lastQuery = '';

      function closePredictive() {
        if (panel) { panel.hidden = true; }
        if (input) { input.setAttribute('aria-expanded', 'false'); }
      }
      function openPredictive() {
        if (panel) { panel.hidden = false; }
        if (input) { input.setAttribute('aria-expanded', 'true'); }
      }

      function esc(s) {
        return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      }
      function render(products, query) {
        if (!list) return;
        if (!products.length) {
          list.innerHTML = '<li><p class="df-predictive__empty">No products found for \u201C' + esc(query) + '\u201D</p></li>';
        } else {
          list.innerHTML = products.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            if (img) { img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=92'; }
            return '<li class="df-predictive__item" role="option">'
              + '<a href="' + esc(p.url) + '">'
              + (img ? '<img src="' + esc(img) + '" alt="" width="46" height="46" loading="lazy">' : '<span></span>')
              + '<span class="df-predictive__title">' + esc(p.title) + '</span>'
              + '<span class="df-predictive__price">' + esc(moneyFromString(p.price)) + '</span>'
              + '</a></li>';
          }).join('');
        }
        if (allLink) {
          allLink.href = ((window.dfRoutes && window.dfRoutes.search) || '/search') + '?q=' + encodeURIComponent(query) + '&type=product';
          allLink.textContent = 'See all results for \u201C' + query + '\u201D';
        }
        openPredictive();
      }

      function fetchSuggestions(query) {
        var base = (window.dfRoutes && window.dfRoutes.predictive) || '/search/suggest';
        var url = base + '.json?q=' + encodeURIComponent(query)
          + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (query !== lastQuery) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            render(products, query);
          })
          .catch(function () {});
      }

      if (input) {
        input.addEventListener('input', function () {
          var q = input.value.trim();
          lastQuery = q;
          clearTimeout(debounce);
          if (q.length < 2) { closePredictive(); return; }
          debounce = setTimeout(function () { fetchSuggestions(q); }, 250);
        });
        input.addEventListener('focus', function () {
          if (input.value.trim().length >= 2 && list && list.children.length) openPredictive();
        });
      }
      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-df-search-wrap]')) closePredictive();
      });

      /* Category selector: browse to collection when no query is typed */
      if (form && catSelect) {
        form.addEventListener('submit', function (e) {
          var q = input ? input.value.trim() : '';
          if (!q && catSelect.value) {
            e.preventDefault();
            window.location.href = catSelect.value;
          }
        });
        catSelect.addEventListener('change', function () {
          var q = input ? input.value.trim() : '';
          if (!q && catSelect.value) { window.location.href = catSelect.value; }
        });
      }
    }

    /* ---------- Escape key ---------- */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closePanel(document.querySelector('[data-df-mobile].is-open'));
      closePanel(document.querySelector('[data-df-cart].is-open'));
      closeMega();
      var mcPanel = document.querySelector('[data-df-mobcats]');
      if (mcPanel && !mcPanel.hidden) mcPanel.hidden = true;
      var pp = document.querySelector('[data-df-predictive]');
      if (pp && !pp.hidden) {
        pp.hidden = true;
        var si = document.querySelector('[data-df-search-input]');
        if (si) { si.setAttribute('aria-expanded', 'false'); si.focus(); }
      }
    });

    /* ---------- Wishlist count (native theme wishlist, localStorage) ---------- */
    function updateWishlistCount() {
      var el = document.querySelector('[data-df-wishlist-count]');
      if (!el) return;
      var raw = '';
      try { raw = localStorage.getItem('shopify-wishlist') || ''; } catch (err) { raw = ''; }
      var n = raw ? raw.split(',').filter(Boolean).length : 0;
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    }
    updateWishlistCount();
    window.addEventListener('storage', updateWishlistCount);
    document.addEventListener('click', function () { setTimeout(updateWishlistCount, 600); });

    /* ---------- Cart drawer ---------- */
    function renderCart(cart) {
      var bodyEl = document.querySelector('[data-df-cart-body]');
      var footEl = document.querySelector('[data-df-cart-foot]');
      if (!bodyEl) return;
      updateCount(cart.item_count);
      updateTotal(cart.total_price);
      if (!cart.items || cart.items.length === 0) {
        bodyEl.innerHTML = '<p class="df-cart__empty">Your cart is empty.</p>';
        if (footEl) footEl.hidden = true;
        return;
      }
      var html = '';
      cart.items.forEach(function (item) {
        html += '<div class="df-cart__line" data-key="' + item.key + '">'
          + (item.image ? '<img src="' + item.image.replace(/(\.[^.]+)$/, '_120x$1') + '" alt="' + (item.product_title || '') + '" width="64" height="64" loading="lazy">' : '<span></span>')
          + '<div><a class="df-cart__line-title" href="' + item.url + '">' + item.product_title + '</a>'
          + '<div class="df-cart__line-price">' + money(item.final_line_price) + '</div>'
          + '<div class="df-cart__qty"><button type="button" data-df-qty="dec" aria-label="Decrease">&minus;</button><span>' + item.quantity + '</span><button type="button" data-df-qty="inc" aria-label="Increase">+</button></div>'
          + '</div>'
          + '<button type="button" class="df-cart__remove" data-df-remove aria-label="Remove">Remove</button>'
          + '</div>';
      });
      bodyEl.innerHTML = html;
      if (footEl) {
        footEl.hidden = false;
        var sub = footEl.querySelector('[data-df-cart-subtotal]');
        if (sub) sub.textContent = money(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
      }
    }

    function updateCount(n) {
      document.querySelectorAll('[data-df-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.classList.toggle('is-empty', n === 0);
      });
    }
    function updateTotal(cents) {
      document.querySelectorAll('[data-df-cart-total]').forEach(function (el) {
        el.textContent = money(cents);
      });
    }

    function fetchCart() {
      var base = (window.dfRoutes && window.dfRoutes.cart) || '/cart';
      return fetch(base + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }

    function openCart() {
      var drawer = document.querySelector('[data-df-cart]');
      openPanel(drawer);
      var bodyEl = document.querySelector('[data-df-cart-body]');
      if (bodyEl) bodyEl.innerHTML = '<p class="df-cart__loading">Loading…</p>';
      fetchCart().then(renderCart).catch(function(){ if (bodyEl) bodyEl.innerHTML = '<p class="df-cart__empty">Could not load cart.</p>'; });
    }

    function changeLine(key, qty) {
      var url = (window.dfRoutes && window.dfRoutes.cartChange) || '/cart/change';
      return fetch(url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    }

    document.addEventListener('click', function (e) {
      var line = e.target.closest('.df-cart__line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var qtyEl = line.querySelector('.df-cart__qty span');
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

      if (e.target.closest('[data-df-remove]')) {
        e.preventDefault();
        changeLine(key, 0).then(renderCart);
      } else if (e.target.closest('[data-df-qty="inc"]')) {
        e.preventDefault();
        changeLine(key, current + 1).then(renderCart);
      } else if (e.target.closest('[data-df-qty="dec"]')) {
        e.preventDefault();
        changeLine(key, Math.max(0, current - 1)).then(renderCart);
      }
    });

    // Keep count/total in sync on load
    if (document.querySelector('[data-df-cart-count]')) {
      fetchCart().then(function (c) { updateCount(c.item_count); updateTotal(c.total_price); }).catch(function(){});
    }

    // Allow other sections to open/refresh the cart drawer
    document.addEventListener('df:cart:open', function () { openCart(); });
    document.addEventListener('df:cart:refresh', function () {
      fetchCart().then(function (c) { updateCount(c.item_count); updateTotal(c.total_price); }).catch(function(){});
    });

    // Centralized quick add-to-cart (used by product rows and local pages)
    if (!window.dfQuickAddBound) {
      window.dfQuickAddBound = true;
      document.addEventListener('click', function (e) {
        var addBtn = e.target.closest('[data-df-add]');
        if (!addBtn || addBtn.getAttribute('aria-busy') === 'true') return;
        e.preventDefault();
        var vid = addBtn.getAttribute('data-variant-id');
        if (!vid) return;
        addBtn.setAttribute('aria-busy', 'true');
        var original = addBtn.getAttribute('data-df-add-label') || addBtn.textContent;
        addBtn.setAttribute('data-df-add-label', original);
        var errorEl = addBtn.parentElement.querySelector('[data-df-add-error]');
        if (!errorEl) {
          errorEl = document.createElement('p');
          errorEl.setAttribute('data-df-add-error', '');
          errorEl.setAttribute('role', 'alert');
          addBtn.parentElement.appendChild(errorEl);
        }
        errorEl.hidden = true;
        fetch(((window.dfRoutes && window.dfRoutes.cartAdd) || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            addBtn.removeAttribute('aria-busy');
            addBtn.textContent = res.ok ? '\u2713 Added' : '\u2717';
            setTimeout(function () { addBtn.textContent = original; }, 1500);
            if (res.ok) { openCart(); }
            else { errorEl.textContent = res.data.description || res.data.message || 'Could not add this product. Please try again.'; errorEl.hidden = false; }
          })
          .catch(function () { addBtn.removeAttribute('aria-busy'); addBtn.textContent = original; errorEl.textContent = 'Could not connect to the cart. Please try again.'; errorEl.hidden = false; });
      });
    }

    /* ---------- Sticky ---------- */
    var dfh = document.querySelector('df-header');
    if (dfh) {
      var wrapper = dfh.closest('.df-header-section') || dfh.parentElement;
      var stickyOn = dfh.getAttribute('data-sticky') === 'true';
      if (!stickyOn) {
        if (wrapper) wrapper.classList.add('df-sticky-off');
      } else {
        var stuck = false;
        var onScroll = function () {
          var shouldStick = window.scrollY > 140;
          if (shouldStick !== stuck) {
            stuck = shouldStick;
            dfh.classList.toggle('df-is-stuck', stuck);
            if (stuck) closeMega();
          }
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["df-product-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Quick add-to-cart is handled centrally in the header section.

    // Carousel arrows
    function initRow(section) {
      var track = section.querySelector('[data-df-track]');
      var arrows = section.querySelector('[data-df-arrows]');
      if (!track || !arrows) return;
      var prev = section.querySelector('[data-df-prev]');
      var next = section.querySelector('[data-df-next]');
      function overflowing() { return track.scrollWidth > track.clientWidth + 4; }
      function update() {
        if (!overflowing()) { arrows.hidden = true; return; }
        arrows.hidden = false;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      function step() { return Math.max(track.clientWidth * 0.8, 240); }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }
    function boot() { document.querySelectorAll('.df-prow').forEach(initRow); }
    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["df-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-df-pdp]');
    if (!root || root.dataset.dfInit === '1') return;
    root.dataset.dfInit = '1';

    /* ---------- Gallery ---------- */
    var track = root.querySelector('[data-df-gallery]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-df-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.df-pdp__dot'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-df-slide]'));

    function setActive(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function goTo(i) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.index, 10)); });
    });
    if (track) {
      var scrollT = null;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollT);
        scrollT = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          setActive(Math.max(0, Math.min(slides.length - 1, i)));
        }, 80);
      }, { passive: true });
    }

    /* ---------- Variants ---------- */
    var variantsEl = root.querySelector('[data-df-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : null;
    var optionSelects = Array.prototype.slice.call(root.querySelectorAll('[data-df-option]'));
    var atcButtons = Array.prototype.slice.call(root.querySelectorAll('[data-df-atc]'));

    function currentVariant() {
      if (!variants) return null;
      var chosen = optionSelects.map(function (s) { return s.value; });
      for (var v = 0; v < variants.length; v++) {
        var match = true;
        for (var o = 0; o < chosen.length; o++) {
          if (variants[v].options[o] !== chosen[o]) { match = false; break; }
        }
        if (match) return variants[v];
      }
      return null;
    }

    function applyVariant(v) {
      if (!v) return;
      atcButtons.forEach(function (b) {
        b.setAttribute('data-variant-id', v.id);
        b.disabled = !v.available;
        var label = b.querySelector('[data-df-atc-label]');
        if (label) label.textContent = v.available ? label.getAttribute('data-df-original') || label.textContent.replace('Out of stock', 'Add to cart') : 'Out of stock';
      });
      var cur = root.querySelector('[data-df-price-current]');
      var was = root.querySelector('[data-df-price-was]');
      var badge = root.querySelector('[data-df-price-badge]');
      var sticky = root.querySelector('[data-df-sticky-price]');
      if (cur) { cur.textContent = v.price; cur.classList.toggle('is-sale', !!v.compare); }
      if (sticky) { sticky.textContent = v.price; }
      if (was) { was.hidden = !v.compare; if (v.compare) was.textContent = v.compare; }
      if (badge) { badge.hidden = !v.compare; }
      if (v.media) {
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(v.media); });
        if (idx > -1) goTo(idx);
      }
    }
    atcButtons.forEach(function (b) {
      var label = b.querySelector('[data-df-atc-label]');
      if (label) label.setAttribute('data-df-original', label.textContent);
    });
    optionSelects.forEach(function (s) {
      s.addEventListener('change', function () { applyVariant(currentVariant()); });
    });

    /* ---------- Quantity ---------- */
    var qtyInput = root.querySelector('[data-df-qty-input]');
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-df-qty]');
      if (!btn || !qtyInput) return;
      var val = parseInt(qtyInput.value, 10) || 1;
      if (btn.getAttribute('data-df-qty') === 'inc') { val += 1; } else { val -= 1; }
      qtyInput.value = Math.max(1, Math.min(99, val));
    });

    /* ---------- Add to cart ---------- */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-df-atc]');
      if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
      e.preventDefault();
      var vid = btn.getAttribute('data-variant-id');
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      btn.setAttribute('aria-busy', 'true');
      var label = btn.querySelector('[data-df-atc-label]');
      var original = label ? (label.getAttribute('data-df-original') || label.textContent) : '';
      var errorEl = root.querySelector('[data-df-cart-error]');
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          btn.removeAttribute('aria-busy');
          if (label) {
            label.textContent = res.ok ? '\u2713 Added' : 'Try again';
            setTimeout(function () { label.textContent = original; }, 1600);
          }
          if (!res.ok && errorEl) {
            errorEl.textContent = res.data.description || res.data.message || 'Could not add this product. Please try again.';
            errorEl.hidden = false;
          }
          if (res.ok) {
            document.dispatchEvent(new CustomEvent('df:cart:refresh'));
            document.dispatchEvent(new CustomEvent('df:cart:open'));
          }
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          if (label) label.textContent = original;
          if (errorEl) { errorEl.textContent = 'Could not connect to the cart. Please try again.'; errorEl.hidden = false; }
        });
    });

    /* ---------- Sticky mobile bar ---------- */
    var stickyBar = root.querySelector('[data-df-sticky]');
    var mainBuy = root.querySelector('.df-pdp__buy');
    if (stickyBar && mainBuy && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        var mobile = window.matchMedia('(max-width: 989px)').matches;
        stickyBar.hidden = visible || !mobile;
      }, { rootMargin: '-60px 0px 0px 0px' });
      io.observe(mainBuy);
    }

    /* ---------- Recently viewed recorder ---------- */
    try {
      var handle = window.location.pathname.split('/products/')[1];
      if (handle) {
        handle = handle.split('?')[0].split('/')[0];
        var key = 'df-recently-viewed';
        var list = (localStorage.getItem(key) || '').split(',').filter(Boolean);
        list = list.filter(function (h) { return h !== handle; });
        list.unshift(handle);
        localStorage.setItem(key, list.slice(0, 12).join(','));
      }
    } catch (err) { /* private mode */ }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["df-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function esc(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    var moneyPlaceholder = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
    function money(cents) {
      var fmt = window.dfMoneyFormat || '';
      var m = fmt.match(moneyPlaceholder);
      var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return m ? fmt.replace(m[0], v) : v;
    }
    function card(p) {
      var img = p.featured_image || '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
      var v = p.variants && p.variants[0];
      var multi = p.variants && p.variants.length > 1;
      var buy;
      if (!p.available) {
        buy = '<a href="/products/' + esc(p.handle) + '" class="df-prow__add df-prow__add--out">Sold out</a>';
      } else if (multi) {
        buy = '<a href="/products/' + esc(p.handle) + '" class="df-prow__add df-prow__add--options">View options</a>';
      } else {
        buy = '<button type="button" class="df-prow__add" data-df-add data-variant-id="' + v.id + '">Add to cart</button>';
      }
      return '<div class="df-prow__card">'
        + '<a href="/products/' + esc(p.handle) + '" class="df-prow__media" aria-label="' + esc(p.title) + '">'
        + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="300" height="300" loading="lazy">' : '')
        + '</a>'
        + '<div class="df-prow__info">'
        + '<a href="/products/' + esc(p.handle) + '" class="df-prow__title">' + esc(p.title) + '</a>'
        + '<div class="df-prow__price"><span>' + money(p.price) + '</span></div>'
        + buy
        + '</div></div>';
    }
    function init(section) {
      if (section.dataset.dfInit === '1') return;
      section.dataset.dfInit = '1';
      var current = section.getAttribute('data-current');
      var limit = parseInt(section.getAttribute('data-limit'), 10) || 8;
      var handles = [];
      try { handles = (localStorage.getItem('df-recently-viewed') || '').split(',').filter(Boolean); } catch (e) { return; }
      handles = handles.filter(function (h) { return h !== current; }).slice(0, limit);
      if (!handles.length) return;
      var track = section.querySelector('[data-df-recent-track]');
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (products) {
        var ok = products.filter(Boolean);
        if (!ok.length || !track) return;
        track.innerHTML = ok.map(card).join('');
        section.hidden = false;
      });
    }
    function boot() { document.querySelectorAll('[data-df-recent]').forEach(init); }
    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["df-related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      if (section.dataset.dfInit === '1') return;
      section.dataset.dfInit = '1';
      var url = section.getAttribute('data-url');
      if (!url || section.querySelector('.df-prow__card')) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-df-related]');
          if (fresh && fresh.querySelector('.df-prow__card')) {
            section.innerHTML = fresh.innerHTML;
          }
        })
        .catch(function () {});
    }
    function boot() { document.querySelectorAll('[data-df-related]').forEach(init); }
    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  // Liquid tags are not rendered inside javascript blocks; a DOM guard
  // replaces the old Liquid condition so the compiled bundle stays valid JS.
  var couponCodeField = document.getElementById('coupon_code_cart');
  if (couponCodeField) {
    couponCodeField.value = localStorage.getItem('coupon') || '';
  }

  } catch(e) { console.error(e); }
})();
})();
